/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { CallerType } from '../../models/caller-type';
import { SeatmapSvgAndControlData } from '../../models/seatmap-svg-and-control-data';
import { StandaloneSeatmapParams } from '../../models/standalone-seatmap-params';

export interface GetStandaloneSeatmap$Params {
  Caller?: CallerType;
      body: StandaloneSeatmapParams
}

export function getStandaloneSeatmap(http: HttpClient, rootUrl: string, params: GetStandaloneSeatmap$Params, context?: HttpContext): Observable<DapiHttpResponse<SeatmapSvgAndControlData>> {
  const rb = new DapiRequestBuilder(rootUrl, getStandaloneSeatmap.PATH, 'post');

  if (params) {
    rb.header('Caller', params.Caller, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<SeatmapSvgAndControlData>;
    }),
    catchErrorAsJson()
  );
}

getStandaloneSeatmap.PATH = '/api/seatmap';
